// src/components/AssignDocument.jsx
import React, { useEffect, useState } from "react";
import "../assets/AssignDocument.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileCsv,
  faFileExcel,
  faPrint,
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchDocuments,
  addDocument,
  toggleAssign,
  toggleMandate,
  resetDocuments,
} from "../redux/slices/documentSlice";
import { toast } from "react-toastify";
import axios from "axios";
import { FaTrash } from "react-icons/fa";

const AssignDocument = () => {
  const dispatch = useDispatch();
  const {
    documents = [],
    loading,
    error,
  } = useSelector((state) => state.documents || {});

  useEffect(() => {
    dispatch(resetDocuments()); // safe reset
  }, [dispatch]);

  const [newDocumentName, setNewDocumentName] = useState("");
  const [newDocumentType, setNewDocumentType] = useState("");
  const [newDocumentRole, setNewDocumentRole] = useState("");
  const [newDocumentsearch, setNewDocumentsearch] = useState("");
  const [newDocumentDescription, setNewDocumentDescription] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedServiceType, setSelectedServiceType] = useState("CC Loan");
  const [selectedServiceRole, setSelectedServiceRole] = useState("");

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(documents.length / itemsPerPage);

  // useEffect(() => {
  //   dispatch(fetchDocuments());
  // }, [dispatch]);

  //   useEffect(() => {
  //   dispatch(fetchDocuments({
  //     serviceId: localStorage.getItem("adminuserId")
  //   }));
  // }, [dispatch]);

  const handleAddDocument = () => {
    if (newDocumentName.trim() && newDocumentType && newDocumentRole) {
      dispatch(
        addDocument({
          name: newDocumentName.trim(),
          description: newDocumentRole,
          imageType: newDocumentType,
          serviceId: localStorage.getItem("adminuserId"),
          subServiceId: localStorage.getItem("adminuserId"),
        }),
      )
        .unwrap()
        .then((res) => {
          toast.success(res.message || "Document added successfully!");

          setNewDocumentName("");
          setNewDocumentType("");
          setNewDocumentRole("");
          setNewDocumentDescription("");
          setIsModalOpen(false);
          dispatch(
            fetchDocuments({
              serviceId: localStorage.getItem("adminuserId"),
              description: newDocumentsearch || undefined,
            }),
          );
        })
        .catch((error) => {
          toast.error(error||"Failed to add document.");
        });
    } else {
      toast.warn("Please fill in all required fields.");
    }
  };

  const handleToggleAssign = async (id, assigned) => {
    try {
      await dispatch(
        toggleAssign({
          id,
          serviceId: localStorage.getItem("adminuserId"),
          subServiceId: localStorage.getItem("adminuserId"),
        }),
      ).unwrap();
      toast.success(
        `Document ${assigned ? "deassigned" : "assigned"} successfully.`,
      );
      dispatch(fetchDocuments());
    } catch {
      toast.error("Failed to update assignment status.");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this document?")) return;
    console.log(id);
    // setSubmitting(true);
    try {
      await axios.delete(`https://payyug.in/api/documents/${id}`);
      // await dispatch(fetchAllFees());
      dispatch(
        fetchDocuments({
          // serviceId: localStorage.getItem("adminuserId"), // or selectedServiceType’s id
          description: newDocumentsearch, // Customer / Employe
        }),
      );
      alert("Deleted successfully");
    } catch (err) {
      console.error("Delete error:", err);
      // setError("Delete failed.");
    } finally {
      // setSubmitting(false);
    }
  };

  const handleToggleMandate = async (id, mandatory) => {
    try {
      await dispatch(
        toggleMandate({
          id,
          serviceId: localStorage.getItem("adminuserId"),
          subServiceId: localStorage.getItem("adminuserId"),
        }),
      ).unwrap();
      toast.success(
        `Document ${mandatory ? "unmarked" : "marked"} as mandatory.`,
      );
      dispatch(fetchDocuments());
    } catch {
      toast.error("Failed to update mandate status.");
    }
  };

  // Paginated slice
  const paginatedDocuments = documents.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleSearch = () => {
    console.log("newDocument =", newDocumentsearch);
    if (newDocumentsearch === "") {
      dispatch(
      fetchDocuments({
        serviceId: localStorage.getItem("adminuserId"),
        description: newDocumentsearch || undefined,
      }),
    );
  return;
} else {
      //  dispatch(fetchDocuments({
      // // serviceId: localStorage.getItem("adminuserId"), // or selectedServiceType’s id
      //   description: newDocumentsearch // Customer / Employe
      // }));

      dispatch(
        fetchDocuments({
          serviceId: localStorage.getItem("adminuserId"),
          description: newDocumentsearch || undefined,
        }),
      );
    }
  };

  return (
    <main className="AssignDocument-container">
      <section className="AssignDocument-section-top">
        <header className="AssignDocument-header-top">
          <div>
            <h1 className="AssignDocument-title">
              Service/Role Document Assignment
            </h1>
            <p className="AssignDocument-subtitle">
              Assign documents to services and roles for KYC.
            </p>
          </div>
          <button
            className="AssignDocument-add-button"
            onClick={() => setIsModalOpen(true)}
          >
            Add Document
          </button>
        </header>

        <form
          className="AssignDocument-form"
          onSubmit={(e) => e.preventDefault()}
        >
          <div className="AssignDocument-form-group">
            <select
              value={newDocumentsearch}
              onChange={(e) => setNewDocumentsearch(e.target.value)}
              className="AssignDocument-modal-input"
            >
              <option value="">-- Select Role --</option>
              <option value="Customer">Customer</option>
              <option value="Employe">Employe</option>
              <option value="Loan">Loan</option>
              <option value="Banking">Banking</option>
            </select>
          </div>

          <div className="AssignDocument-button-group">
            <button
              type="submit"
              onClick={handleSearch}
              className="AssignDocument-search-button"
            >
              Search
            </button>
          </div>
        </form>
      </section>

      <section className="AssignDocument-section">
        <div className="AssignDocument-action">
          <h2 className="AssignDocument-subheading">Service List</h2>
          {/* <p className="AssignDocument-subtext">Assign or deassign documents.</p> */}
          <div className="assign-doc-btn">
            <button className="AssignDocument-btncsv">
              <FontAwesomeIcon icon={faFileCsv} /> CSV
            </button>
            <button className="AssignDocument-btnexcel">
              <FontAwesomeIcon icon={faFileExcel} /> Excel
            </button>
            <button className="AssignDocument-btnprint">
              <FontAwesomeIcon icon={faPrint} /> Print
            </button>
          </div>
        </div>

        {loading ? (
          <p>Loading documents...</p>
        ) : error ? (
          <p className="error-text">{error}</p>
        ) : (
          <>
            <div className="AssignDocument-table-wrapper">
              <table className="AssignDocument-table">
                <thead>
                  <tr>
                    <th>SN</th>
                    <th>DOCUMENT NAME</th>
                    <th>DOCUMENT TYPE</th>
                    <th>ASSIGN/DEASSIGN</th>
                    <th>MANDATE/DEMANDATE</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedDocuments.map((doc, index) => (
                    <tr key={doc.id}>
                      <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                      <td>{doc.name || "N/A"}</td>
                      <td>{doc.imageType?.toUpperCase() || "N/A"}</td>
                      <td>
                        <input
                          type="checkbox"
                          className="AssignDocument-toggle-switch"
                          checked={doc.assigned}
                          onChange={() =>
                            handleToggleAssign(doc.id, doc.assigned)
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          className="AssignDocument-toggle-switch AssignDocument-mandate-toggle"
                          checked={doc.mandatory}
                          onChange={() =>
                            handleToggleMandate(doc.id, doc.mandatory)
                          }
                        />
                      </td>
                      <td>
                        <button
                          className="AssignDocument-deleteButton"
                          onClick={() => handleDelete(doc.id)}
                          aria-label="Delete document"
                        >
                          <FaTrash />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination Controls */}
            <div className="pagination-controls">
              <button
                disabled={currentPage === 1}
                onClick={() => handlePageChange(currentPage - 1)}
              >
                &laquo; Prev
              </button>
              {[...Array(totalPages)].map((_, i) => (
                <button
                  key={i + 1}
                  className={currentPage === i + 1 ? "active" : ""}
                  onClick={() => handlePageChange(i + 1)}
                >
                  {i + 1}
                </button>
              ))}
              <button
                disabled={currentPage === totalPages}
                onClick={() => handlePageChange(currentPage + 1)}
              >
                Next &raquo;
              </button>
            </div>
          </>
        )}
      </section>

      {isModalOpen && (
        <div className="AssignDocument-modal-overlay">
          <div className="AssignDocument-modal">
            <h3 className="AssignDocument-modal-title">Add New Document</h3>

            <div className="AssignDocument-modal-field">
              <label>Document Name</label>
              <input
                type="text"
                value={newDocumentName}
                onChange={(e) => setNewDocumentName(e.target.value)}
                placeholder="Enter document name"
                className="AssignDocument-modal-input"
              />
            </div>

            <div className="AssignDocument-modal-field">
              <label>Document Type</label>
              <select
                value={newDocumentType}
                onChange={(e) => setNewDocumentType(e.target.value)}
                className="AssignDocument-modal-input"
              >
                <option value="">-- Select Type --</option>
                {/* <option value="pdf">PDF</option> */}
                <option value="png">PNG</option>
                <option value="jpg">JPG</option>
                <option value="jpeg">JPEG</option>
              </select>
            </div>
            <div className="AssignDocument-modal-field">
              <label>Assign To</label>
              <select
                value={newDocumentRole}
                onChange={(e) => setNewDocumentRole(e.target.value)}
                className="AssignDocument-modal-input"
              >
                <option value="">-- Select Role --</option>
                <option value="Customer">Customer</option>
                <option value="Employe">Employe</option>
                <option value="Loan">Loan</option>
                <option value="Banking">Banking</option>
              </select>
            </div>

            <div className="AssignDocument-modal-field">
              {/* <label>Description</label>
              <textarea
                value={newDocumentDescription}
                onChange={(e) => setNewDocumentDescription(e.target.value)}
                placeholder="Enter description"
                className="AssignDocument-modal-input"
                rows="3"
              /> */}
            </div>

            <div className="AssignDocument-modal-buttons">
              <button
                onClick={handleAddDocument}
                className="AssignDocument-modal-save"
              >
                Save
              </button>
              <button
                onClick={() => setIsModalOpen(false)}
                className="AssignDocument-modal-cancel"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </main>
  );
};

export default AssignDocument;





// // src/components/AssignDocument.jsx
// import React, { useEffect, useState } from 'react';
// import '../assets/AssignDocument.css';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faFileCsv, faFileExcel, faPrint } from '@fortawesome/free-solid-svg-icons';
// import { useDispatch, useSelector } from 'react-redux';
// import {
//   fetchDocuments,
//   addDocument,
//   toggleAssign,
//   toggleMandate,
//   resetDocuments,
// } from '../redux/slices/documentSlice';
// import { toast } from 'react-toastify';
// import axios from 'axios';
// import { FaTrash } from 'react-icons/fa';

// const BASE_URL = process.env.REACT_APP_API_URL;

// const AssignDocument = () => {
//   const dispatch = useDispatch();
//   const { documents = [], loading, error } = useSelector(state => state.documents || {});

//   // ❌ NO initial fetch
//   useEffect(() => {
//     dispatch(resetDocuments());
//   }, [dispatch]);

//   const [newDocumentName, setNewDocumentName] = useState('');
//   const [newDocumentType, setNewDocumentType] = useState('');
//   const [newDocumentRole, setNewDocumentRole] = useState('');
//   const [newDocumentsearch, setNewDocumentsearch] = useState('');
//   const [newDocumentDescription, setNewDocumentDescription] = useState('');
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   // PAGINATION
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;
//   const totalPages = Math.ceil(documents.length / itemsPerPage);

//   const paginatedDocuments = documents.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage
//   );

//   // ✅ SEARCH
//   const handleSearch = () => {
//     setCurrentPage(1);

//     dispatch(fetchDocuments({
//       serviceId: localStorage.getItem("adminuserId"),
//       description: newDocumentsearch || undefined
//     }));
//   };

//   // ✅ ADD
//   const handleAddDocument = () => {
//     if (newDocumentName.trim() && newDocumentType && newDocumentRole) {
//       dispatch(
//         addDocument({
//           name: newDocumentName.trim(),
//           description: newDocumentRole,
//           imageType: newDocumentType,
//           serviceId: localStorage.getItem("adminuserId"),
//           subServiceId: localStorage.getItem("adminuserId")
//         })
//       )
//         .unwrap()
//         .then(() => {
//           toast.success('Document added successfully!');

//           setCurrentPage(1);
//           handleSearch();

//           setNewDocumentName('');
//           setNewDocumentType('');
//           setNewDocumentRole('');
//           setNewDocumentDescription('');
//           setIsModalOpen(false);
//         })
//         .catch(() => {
//           toast.error('Failed to add document.');
//         });
//     } else {
//       toast.warn('Please fill in all required fields.');
//     }
//   };

//   // ✅ TOGGLE ASSIGN (no refetch)
//   const handleToggleAssign = async (id, assigned) => {
//     try {
//       await dispatch(toggleAssign({
//         id,
//         serviceId: localStorage.getItem("adminuserId"),
//         subServiceId: localStorage.getItem("adminuserId")
//       })).unwrap();

//       toast.success(`Document ${assigned ? 'deassigned' : 'assigned'} successfully.`);
//     } catch {
//       toast.error('Failed to update assignment status.');
//     }
//   };

//   // ✅ TOGGLE MANDATE
//   const handleToggleMandate = async (id, mandatory) => {
//     try {
//       await dispatch(toggleMandate({
//         id,
//         serviceId: localStorage.getItem("adminuserId"),
//         subServiceId: localStorage.getItem("adminuserId")
//       })).unwrap();

//       toast.success(`Document ${mandatory ? 'unmarked' : 'marked'} as mandatory.`);
//     } catch {
//       toast.error('Failed to update mandate status.');
//     }
//   };

//   // ✅ DELETE
//   const handleDelete = async (id) => {
//     if (!window.confirm("Are you sure you want to delete this scheme?")) return;

//     try {
//       await axios.delete(`${BASE_URL}/documents/${id}`);

//       setCurrentPage(1);
//       handleSearch();

//       alert("Deleted successfully");
//     } catch (err) {
//       console.error("Delete error:", err);
//     }
//   };

//   return (
//     <main className="AssignDocument-container">
//       <section className="AssignDocument-section-top">
//         <header className="AssignDocument-header-top">
//           <div>
//             <h1 className="AssignDocument-title">Service/Role Document Assignment</h1>
//             <p className="AssignDocument-subtitle">Assign documents to services and roles for KYC.</p>
//           </div>
//           <button className="AssignDocument-add-button" onClick={() => setIsModalOpen(true)}>Add Document</button>
//         </header>

//         <form className="AssignDocument-form" onSubmit={e => e.preventDefault()}>
//           <div className="AssignDocument-form-group">
//             <select
//               value={newDocumentsearch}
//               onChange={(e) => setNewDocumentsearch(e.target.value)}
//               className="AssignDocument-modal-input"
//             >
//               <option value="">-- Select Role --</option>
//               <option value="Customer">Customer</option>
//               <option value="Employe">Employe</option>
//               <option value="Loan">Loan</option>
//               <option value="Banking">Banking</option>
//             </select>
//           </div>

//           <div className="AssignDocument-button-group">
//             <button type="submit" onClick={handleSearch}
//               className="AssignDocument-search-button">Search</button>
//           </div>
//         </form>
//       </section>

//       <section className="AssignDocument-section">
//         <div className="AssignDocument-action">
//           <h2 className="AssignDocument-subheading">Service List</h2>
//           <div className="assign-doc-btn">
//             <button className="AssignDocument-btncsv"><FontAwesomeIcon icon={faFileCsv} /> CSV</button>
//             <button className="AssignDocument-btnexcel"><FontAwesomeIcon icon={faFileExcel} /> Excel</button>
//             <button className="AssignDocument-btnprint"><FontAwesomeIcon icon={faPrint} /> Print</button>
//           </div>
//         </div>

//         {loading ? (
//           <p>Loading documents...</p>
//         ) : error ? (
//           <p className="error-text">{error}</p>
//         ) : documents.length === 0 ? (
//           <p style={{ textAlign: "center" }}>No data. Please search.</p>
//         ) : (
//           <>
//             <div className="AssignDocument-table-wrapper">
//               <table className="AssignDocument-table">
//                 <thead>
//                   <tr>
//                     <th>SN</th>
//                     <th>DOCUMENT NAME</th>
//                     <th>DOCUMENT TYPE</th>
//                     <th>ASSIGN/DEASSIGN</th>
//                     <th>MANDATE/DEMANDATE</th>
//                     <th>Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {paginatedDocuments.map((doc, index) => (
//                     <tr key={doc.id || doc._id}>
//                       <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
//                       <td>{doc.name || "N/A"}</td>
//                       <td>{doc.imageType?.toUpperCase() || "N/A"}</td>
//                       <td>
//                         <input
//                           type="checkbox"
//                           className="AssignDocument-toggle-switch"
//                           checked={!!doc.assigned}
//                           onChange={() => handleToggleAssign(doc.id || doc._id, doc.assigned)}
//                         />
//                       </td>
//                       <td>
//                         <input
//                           type="checkbox"
//                           className="AssignDocument-toggle-switch AssignDocument-mandate-toggle"
//                           checked={!!doc.mandatory}
//                           onChange={() => handleToggleMandate(doc.id || doc._id, doc.mandatory)}
//                         />
//                       </td>
//                       <td>
//                         <button
//                           className="AssignDocument-deleteButton"
//                           onClick={() => handleDelete(doc.id || doc._id)}
//                         >
//                           <FaTrash />
//                         </button>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>

//             {/* ✅ ONLY PAGINATION UI CHANGED */}
//             <div className="pagination-controls">
//               <button
//                 disabled={currentPage === 1}
//                 onClick={() => setCurrentPage(prev => prev - 1)}
//               >
//                 &laquo; Prev
//               </button>

//               <span style={{ margin: "0 10px", fontWeight: "bold" }}>
//                 Page {currentPage} of {totalPages || 1}
//               </span>

//               <button
//                 disabled={currentPage === totalPages || totalPages === 0}
//                 onClick={() => setCurrentPage(prev => prev + 1)}
//               >
//                 Next &raquo;
//               </button>
//             </div>
//           </>
//         )}
//       </section>

//       {/* MODAL (UNCHANGED) */}
//       {isModalOpen && (
//         <div className="AssignDocument-modal-overlay">
//           <div className="AssignDocument-modal">
//             <h3 className="AssignDocument-modal-title">Add New Document</h3>

//             <div className="AssignDocument-modal-field">
//               <label>Document Name</label>
//               <input
//                 type="text"
//                 value={newDocumentName}
//                 onChange={(e) => setNewDocumentName(e.target.value)}
//                 className="AssignDocument-modal-input"
//               />
//             </div>

//             <div className="AssignDocument-modal-field">
//               <label>Document Type</label>
//               <select
//                 value={newDocumentType}
//                 onChange={(e) => setNewDocumentType(e.target.value)}
//                 className="AssignDocument-modal-input"
//               >
//                 <option value="">-- Select Type --</option>
//                 <option value="png">PNG</option>
//                 <option value="jpg">JPG</option>
//                 <option value="jpeg">JPEG</option>
//               </select>
//             </div>

//             <div className="AssignDocument-modal-field">
//               <label>Assign To</label>
//               <select
//                 value={newDocumentRole}
//                 onChange={(e) => setNewDocumentRole(e.target.value)}
//                 className="AssignDocument-modal-input"
//               >
//                 <option value="">-- Select Role --</option>
//                 <option value="Customer">Customer</option>
//                 <option value="Employe">Employe</option>
//                 <option value="Loan">Loan</option>
//                 <option value="Banking">Banking</option>
//               </select>
//             </div>

//             <div className="AssignDocument-modal-buttons">
//               <button onClick={handleAddDocument} className="AssignDocument-modal-save">Save</button>
//               <button onClick={() => setIsModalOpen(false)} className="AssignDocument-modal-cancel">Cancel</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </main>
//   );
// };

// export default AssignDocument;